<template>
  <div class="product-machine">
    <div class="search-group">
      <template v-if="isProduct">
        <div class="input-box">
          <el-input
            size="mini"
            v-model="tableParams.machineModel"
            :placeholder="$lange == 'en' ? 'Please Input' : '请输入机器名称'"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="input-box">
          <el-input
            size="mini"
            v-model="tableParams.sapCode"
            :placeholder="$lange == 'en' ? 'Please Input' : '请输入SAP Code'"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </template>
      <div class="input-box" v-if="!isProduct">
        <el-input
          size="mini"
          v-model="tableParams.jobId"
          :placeholder="$lange == 'en' ? 'Please Input' : '请输入JOB ID'"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="input-box">
        <el-input
          size="mini"
          v-model="tableParams.fiCom"
          :placeholder="$lange == 'en' ? 'Please Input' : '请输入FI Com'"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="input-box">
        <el-input
          size="mini"
          v-model="tableParams.fasSn"
          :placeholder="$lange == 'en' ? 'Please Input' : '请输入FAS SN'"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>

      <el-button type="primary" size="mini" @click="doSearch">{{
        $lange == "en" ? "Search" : "搜索"
      }}</el-button>
      <template v-if="!isProduct">
        <el-button type="primary" size="mini" @click="downloadModel">{{
          $lange == "en" ? "Download Model" : "下载模板"
        }}</el-button>
        <el-button type="primary" size="mini" @click="insertMachine = true">{{
          $lange == "en" ? "Import" : "导入"
        }}</el-button>
      </template>

      <el-button type="primary" size="mini" @click="Export">{{
        $lange == "en" ? "Export" : "导出"
      }}</el-button>

      <el-button type="primary" size="mini" @click="showDialog('addMachine')">{{
        $lange == "en" ? "Add Machine" : "添加机器"
      }}</el-button>
    </div>
    <div class="table-box">
      <cc-table
        :config="machineTableConfig"
        :params="tableParams2"
        :refesh-params="refeshTable"
      ></cc-table>
    </div>
    <el-dialog
      :title="$lange == 'en' ? 'Import Data' : '导入数据'"
      :visible.sync="insertMachine"
      v-loading="dataLoading"
      :element-loading-text="$lange == 'en' ? '' : '正在导入'"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      width="40%"
      @closed="dialogClose"
      append-to-body
    >
      <cc-uploader
        :config="uploaderConf2"
        :useSuccess="true"
        v-model="uploadData.accessoryUrl"
        @upload-success="uploadTrue2"
      />
      <div style="margin-top: 20px">
        <el-button size="mini" @click="insertMachine = false">{{
          $lange == "en" ? "Cancel" : "取消"
        }}</el-button>
        <el-button type="primary" size="mini" @click="insertMachineFile">{{
          $lange == "en" ? "Submit" : "提交"
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$lange == 'en' ? 'Add Machine' : '添加机器'"
      :visible.sync="addMachine"
      width="40%"
      @closed="dialogClose"
      append-to-body
    >
      <el-form
        :model="form"
        size="mini"
        label-width="120px"
        :rules="formRule"
        ref="formRule"
        @submit.native.prevent
        v-loading="formLoading"
      >
        <el-form-item label="JOBID" prop="jobId">
          <el-select
            v-model="form.jobId"
            :placeholder="$lange == 'en' ? 'Please Select' : '请选择JOBID'"
            clearable
          >
            <el-option
              v-for="item in productLists"
              :label="item.jobId"
              :value="item.jobId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$lange == 'en' ? 'Machine Type' : '机器类型'"
          prop="machineType"
        >
          <cc-constant-selector
            style="display: inline-block"
            type="select"
            valType="String"
            :placeholder="$lange == 'en' ? 'Please Select' : '请选择机器类型'"
            v-model="form.machineType"
            code="machineType"
            api="admin/dict/pageTree"
          />
        </el-form-item>
        <el-form-item label="Abb">
          <el-input v-model="form.machineAbbr"></el-input>
        </el-form-item>
        <el-form-item
          prop="machineModel"
          :label="$lange == 'en' ? 'Machine Description(CN)' : '机器描述'"
          style="word-break: normal"
          class="des"
        >
          <el-input v-model="form.machineModel"></el-input>
        </el-form-item>
        <el-form-item
          :label="$lange == 'en' ? 'Machine Description(EN)' : '机器描述'"
          style="word-break: normal"
          class="des"
        >
          <el-input v-model="form.machineEnModel"></el-input>
        </el-form-item>
        <el-form-item label="SAP Code">
          <el-input v-model="form.sapCode"></el-input>
        </el-form-item>
        <el-form-item label="Supplier">
          <el-input v-model="form.supplier"></el-input>
        </el-form-item>
        <el-form-item label="FI COM" prop="fiCom">
          <el-input v-model="form.fiCom"></el-input>
        </el-form-item>
        <el-form-item label="FAS SN">
          <el-input v-model="form.fasSn"></el-input>
        </el-form-item>
        <el-form-item label="Note">
          <el-input v-model="form.note" :rows="6" type="textarea"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="mini"
            @click.prevent="submitForm('formRule')"
            >{{ $lange == "en" ? "Submit" : "提交" }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Document Administration' : '文档管理'"
      :visible.sync="uploadFlag"
      width="40%"
      @closed="dialogClose"
      append-to-body
    >
      <div class="file-lists">
        <cc-table
          :config="fileTableConfig"
          :loadData="false"
          :maxHeight="240"
          :dataArr="uploadForm"
        ></cc-table>
      </div>
      <div class="upload-box">
        <span class="el-dialog__title">{{
          $lange == "en" ? "Document Upload" : "文档上传"
        }}</span>
        <cc-uploader
          :config="uploaderConf2"
          :notFormat="['text/plain']"
          uploadType="dottedMultiple"
          @upload-success="uploadTrue"
        />
      </div>
      <el-button
        style="margin-top: 15px"
        type="primary"
        size="mini"
        @click="submitFile"
        >{{ $lange == "en" ? "Submit" : "提交" }}</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ProductMachine",
  props: {
    isProduct: {
      default: false,
    },
    jobId: {
      default: false,
    },
  },
  watch: {
    jobId: {
      handler() {
        this.tableParams.jobId = this.jobId;
        this.tableParams2.jobId = this.jobId;
        console.log(this.jobId, "aaaa");
      },
    },
  },
  data() {
    return {
      dataLoading: false,
      uploadData: {},
      insertMachine: false,
      // uploadTrue: "",
      uploaderConf2: this.$uploadUtils.config,
      addMachine: false,
      uploadFlag: false,
      machineTableConfig: {
        api: "admin/fsb/machine/query",
        showPager: true,
        columns: [
          {
            prop: "fiCom",
            lable: "FI COM",
            type: "input",
          },
          {
            prop: "jobId",
            lable: "JOBID",
            type: "input",
            minWidth: 100,
          },
          {
            prop: "machineModel",
            lable: this.$lange == "en" ? "Machine Description" : "机器描述",
            type: "input",
            minWidth: 160,
          },
          {
            prop: "machineEnModel",
            // lable: "Machine Description",
            lable:
              this.$lange == "en"
                ? "Machine Description（En）"
                : "机器描述（En）",
            type: "input",
            minWidth: 160,
          },
          {
            prop: "machineType",
            lable: this.$lange == "en" ? "Machine Type" : "机器类型",
            type: "constant",
            constantConfig: {
              api: "admin/dict/pageTree",
              code: "machineType",
              type: "input",
            },
          },
          {
            prop: "machineAbbr",
            lable: "ABB",
            type: "input",
          },
          {
            prop: "sapCode",
            lable: "SAP Code",
            type: "input",
          },
          {
            prop: "fasSn",
            lable: "FAS SN",
            type: "input",
          },
          {
            prop: "supplier",
            lable: "Supplier",
            type: "input",
          },
          {
            prop: "note",
            lable: "NOTE",
            type: "input",
          },
          {
            prop: "updateTime",
            lable: this.$lange == "en" ? "Update time" : "修改时间",
            type: "input",
            minWidth: 160,
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Edit" : "编辑",
            click: (row) => {
              this.edit(row);
            },
          },
          {
            name: this.$lange == "en" ? "Delete" : "删除",
            click: (row) => {
              this.delete(row.id);
            },
          },
          {
            name: this.$lange == "en" ? "Document" : "文档",
            click: (row) => {
              this.editFile(row);
            },
          },
        ],
      },
      fileTableConfig: {
        height: "150",
        columns: [
          {
            prop: "fileNmae",
            lable: "文件名",
            type: "input",
            render: function (row) {
              let res = row.fileName.split(".");
              return `${res[0]}.${res[res.length - 1]}`;
            },
          },
        ],
        buttons: [
          {
            name: "下载",
            click: (row) => {
              this.downloadFile(row, row.fileName);
            },
          },
          {
            name: "删除",
            click: (row, $index) => {
              let index = $index;
              this.deleteFile(row, index);
            },
          },
        ],
      },
      tableParams: {
        machineModel: "",
        sapCode: "",
        jobId: "",
        fiCom: "",
        fasSn: "",
      },
      tableParams2: {
        machineModel: "",
        sapCode: "",
        jobId: "",
        fiCom: "",
        fasSn: "",
      },
      refeshTable: -1,
      productLists: [],
      formLoading: false,
      form: {
        jobId: "",
        machineType: "",
        machineAbbr: "",
        machineModel: "",
        machineEnModel: "",
        sapCode: "",
        supplier: "",
        fiCom: "",
        fasSn: "",
        note: "",
      },
      formRule: {
        jobId: [{ required: true, message: "请选择JOB ID", trigger: "change" }],
        machineType: [
          { required: true, message: "请选择机器类型", trigger: "change" },
        ],
        machineModel: [
          {
            required: true,
            message: "请输入Machine description",
            trigger: "blur",
          },
        ],
        sapCode: [
          { required: true, message: "请输入SAP Code", trigger: "blur" },
        ],
        fiCom: [{ required: true, message: "请输入FI COM", trigger: "blur" }],
        fasSn: [{ required: true, message: "请输入FAS SN", trigger: "blur" }],
      },
      uploadForm: [],
      uploadRule: {
        fileNme: [
          { required: true, message: "请输入资料名称", trigger: "blur" },
        ],
        accessoryUrl: [
          { required: true, message: "请上传文件", trigger: "change" },
        ],
      },
      editId: false,
    };
  },
  methods: {
    doSearch() {
      this.tableParams2 = { ...this.tableParams };
    },
    insertMachineFile() {
      let data = {
        url: this.uploadData.accessoryUrl,
        fileType: this.uploadData.fileName.split(".")[1],
      };
      this.dataLoading = true;
      this.ccRequest
        .do("admin/fsb/machine/excelDataImport", data, "GET")
        .then((res) => {
          //   console.log(res);
          this.$message({
            type: "success",
            message: "导入成功",
          });
          this.dataLoading = false;
          this.refeshTable = new Date().getTime();
          this.insertMachine = false;
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("导入失败：" + err.response.data.message);
          this.dataLoading = false;
          this.insertMachine = false;

          //   this.$message({
          //     type: "error",
          //     message: "导入失败：" + err.message
          //   });
        });
    },
    uploadTrue2(res) {
      this.uploadData = res;
      console.log(res, "1111");
    },
    downloadModel() {
      window.open(
        `${this.$apis.config.server}admin/fsb/machine/downloadMachineTemplate`
      );
    },
    dialogClose() {
      for (let i in this.form) {
        this.form[i] = "";
      }
      this.uploadForm = [];
      this.editId = false;
      this.refeshTable = new Date().getTime();
    },
    showDialog(type) {
      if (this.isProduct) {
        this.form.jobId = this.jobId;
      }
      this[type] = true;
    },
    edit(row) {
      for (let i in this.form) {
        this.form[i] = row[i];
      }
      this.editId = row.id;
      this.showDialog("addMachine");
    },
    delete(id) {
      this.$confirm("此操作会删除该机器, 是否确定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do("admin/fsb/machine/delete", { id: id }, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.refeshTable = new Date().getTime();
            });
        })
        .catch(() => {
          // this.$message({
          //     type: 'info',
          //     message: '已取消删除'
          // });
        });
    },
    editFile(row) {
      this.editId = row.fiCom;
      this.uploadForm = row.accessoryInfoList;
      this.showDialog("uploadFlag");
    },

    downloadFile(data, name) {
      if (data.accessoryUrl.length < 1) {
        return this.$message({
          type: "warning",
          message: "文件错误,请重新上传",
        });
      }

      if (data.fileName.indexOf("pdf") > -1) {
        let pData = {
          url: data.accessoryUrl,
        };
        return this.ccRequest
          .do("admin/fsb/file/aliyun/privateDownloadUrl", pData, "GET")
          .then((res) => {
            axios({
              method: "get",
              url: res.url,
              headers: {
                "Content-Disposition": "attachment",
              },
            }).then((res2) => {
              this.$message({
                type: "success",
                message: "文件已下载",
              });
            });
          });
      }

      this.$message({
        type: "success",
        message: "文件已下载",
      });
      let imageType = ["png", "jpg", "jpeg", "webp"];
      for (let i in imageType) {
        if (data.fileName.indexOf(imageType[i]) > -1) {
          this.downloadImage(data.accessoryUrl, name);
          return false;
        }
      }
      let a = document.createElement("a");
      a.href = data.accessoryUrl;
      a.download = name;
      a.click();
    },
    downloadImage(imgsrc, name) {
      // 下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    deleteFile(row, index) {
      this.$confirm("此操作会删除该资料, 是否确定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.id) {
          let data = {
            id: row.id,
          };
          this.ccRequest
            .do("admin/fsb/accessory/delete", data, "GET")
            .then((res) => {
              console.log("delete");
            });
        }
        this.uploadForm.splice(index, 1);
        this.$message({
          type: "success",
          message: "删除成功",
        });
      });
    },
    //获取产品列表 用于获取jobID数据
    getProduct() {
      this.ccRequest.do("admin/fsb/product/query", {}, "GET").then((res) => {
        if (res.rows && res.rows.length > 0) {
          this.productLists = res.rows;
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.form;
          let text = "添加成功";
          if (this.editId) {
            data.id = this.editId;
            text = "编辑成功";
          }
          if (data.note.length > 200) {
            return this.$message({
              type: "warning",
              message: "note字数过长, 超出200",
            });
          }
          this.formLoading = true;
          this.ccRequest
            .do("admin/fsb/machine/save", data, "POSTJSON")
            .then((res) => {
              this.formLoading = false;
              this.addMachine = false;
              this.$message({
                message: text,
                type: "success",
              });
              this.editId = false;
              this.refeshTable = new Date().getTime();
            })
            .catch((res) => {
              this.formLoading = false;
              this.$message({
                type: "error",
                message: res.response.data.message,
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancelForm(formName) {
      this.$refs[formName].resetFields();
      this.addMachine = false;
    },
    uploadTrue(item) {
      this.uploadForm.push(item);
    },
    submitFile() {
      let data = {
        objType: "machine",
        objId: this.editId,
        batchFileInfoList: this.uploadForm,
      };
      if (this.jobId && this.jobId.length > 0) {
        data.jobId = this.jobId;
      }
      this.ccRequest
        .do("admin/fsb/accessory/batchAdd", data, "POSTJSON")
        .then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.uploadFlag = false;
        });
    },
    checkLanguage() {
      if (this.$lange == "en") {
        this.fileTableConfig = {
          height: "150",
          columns: [
            {
              prop: "fileNmae",
              lable: "File Name",
              type: "input",
              render: function (row) {
                let res = row.fileName.split(".");
                return `${res[0]}.${res[res.length - 1]}`;
              },
            },
          ],
          buttonsLabel: "Operation",
          buttons: [
            {
              name: "Download",
              click: (row) => {
                this.downloadFile(row);
              },
            },
            {
              name: "Delete",
              click: (row, $index) => {
                let index = $index;
                this.deleteFile(row, index);
              },
            },
          ],
        };
      }
    },

    Export() {
      let data = { ...this.tableParams2, lang: this.$lange };
      let text = "";
      for (const key in data) {
        if (data[key]) {
          text += "&" + key + "=" + data[key];
        }
      }
      window.open("/admin/fsb/machine/excelDataExport?appId=fosber" + text);
    },
  },
  mounted() {
    this.checkLanguage();
    if (this.isProduct) {
      // setTimeout(()=>{
      this.$nextTick(() => {
        this.tableParams.jobId = this.jobId;
        this.tableParams.isDevice = true;
        this.tableParams2.jobId = this.jobId;
        this.tableParams2.isDevice = true;
      });

      // },1200)
    }
    this.getProduct();
  },
};
</script>
<style>
.des .el-form-item__label {
  line-height: 16px;
}
</style>
<style scoped lang="scss">
.product-machine {
  background: #fff;
  padding: 20px;

  .input-box {
    margin-right: 20px;
  }

  .search-group {
    display: flex;
    margin-bottom: 20px;
  }
  .file-lists {
    padding-bottom: 40px;
  }
  .upload-box {
    > span {
      display: block;
      margin-bottom: 20px;
    }
    position: relative;
    min-height: 200px;
    border-top: 1px solid #c4c4c4;
    padding-top: 40px;
  }
}
</style>
